import { Element } from 'react-scroll';
import useInView from 'hooks/useInView';
import './Section.css';

/**
 * A scroll-anchored page section with a heading and a fade-in-on-scroll reveal.
 * `name` doubles as the react-scroll anchor and the DOM id.
 */
function Section({ name, title, tone = 'base', children }) {
  const [sectionRef, hasEntered] = useInView();

  return (
    <Element name={name} className={`section section--${tone}`}>
      <div
        ref={sectionRef}
        id={name}
        className={`section__inner${hasEntered ? ' section__inner--visible' : ''}`}
      >
        {title && <h2 className="section__title">{title}</h2>}
        {children}
      </div>
    </Element>
  );
}

export default Section;
